module.exports = __webpack_public_path__ + "static/img/explain@2x.fa3518c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example01/explain@2x.jpg
// module id = e212
// module chunks = 1